var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
var TextColorDirective = /** @class */ (function () {
    function TextColorDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.setColor();
    }
    TextColorDirective.prototype.setColor = function () {
        var text_color = '#000000';
        if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
            var base_data = JSON.parse(localStorage.getItem('base_data'));
            if (base_data['color']) {
                text_color = base_data['color'];
            }
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'color', text_color);
    };
    TextColorDirective = __decorate([
        Directive({
            selector: '[text-color]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer])
    ], TextColorDirective);
    return TextColorDirective;
}());
export { TextColorDirective };
//# sourceMappingURL=text-color.js.map


// WEBPACK FOOTER //
// ./src/directives/text-color/text-color.ts.pre-build-optimizer.js